import { Injectable } from '@angular/core';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { AppTextService } from '@fi-shared/app-text';
import { IItemsListPublicMethods } from '@fi-shared/fi-items-list/fi-items-list';
import { Subject } from 'rxjs';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';

interface IParseStateParamsResult {
    filterType?: SideListOptionType;
    initialOffset?: number;
}

@Injectable()
export class FiItemsListHelperService {
    constructor(
        private appTextService: AppTextService,
        private fiStateService: FiStateService,
    ) {}

    getSelectedTextByObjectType(objectType: number, isPlural: boolean) {
        const singular =
            objectType === ObjectTypes.Area ||
            objectType === ObjectTypes.BusinessArea ||
            objectType === ObjectTypes.Cluster ||
            objectType === ObjectTypes.Forum
                ? 'selected.singular.2'
                : 'selected.singular.1'; // swedish hack
        return this.appTextService.get(!isPlural ? singular : 'selected.plural');
    }

    getDummyListMethods(): IItemsListPublicMethods<any> {
        return {
            getFilterType: () => SideListOptionType.All,
            reloadData: () => {},
            removeData: (items) => {},
        };
    }

    private _extendedSearchSelectionChanged$ = new Subject<any[]>();
    get extendedSearchSelectionChanged$() {
        return this._extendedSearchSelectionChanged$.asObservable();
    }
    triggerExtendedSearchSelectionChanged(selectedItems: any[]) {
        this._extendedSearchSelectionChanged$.next(selectedItems);
    }

    parseStateParams(args: {
        extendedSearchMode: boolean;
        defaultFilterType: SideListOptionType;
        mobileAppMode: boolean;
        //defaultSortColumnName: string;
        //defaultSortDirection: boolean;
    }): IParseStateParamsResult {
        const result: IParseStateParamsResult = {};
        if (args.extendedSearchMode) {
            result.filterType = args.defaultFilterType;
        } else if (!args.mobileAppMode) {
            const params = this.fiStateService.params;
            result.filterType = params.filterType ? coerceNumberProperty(params.filterType) : args.defaultFilterType;
            result.initialOffset = coerceNumberProperty(params.offset);
        } else {
            result.filterType = args.defaultFilterType;
            //result.sortColumn = this.defaultSortColumnName;
            //result.sortDirection = this.defaultSortDirection;
        }
        return result;
    }

    updateStateParams(args: {
        extendedSearchMode: boolean;
        mobileAppMode: boolean;
        filterType: SideListOptionType;
        sortColumn: string;
        sortDirection: boolean;
        selectedTagId: number;
    }) {
        if (args.extendedSearchMode) {
            return;
        }
        if (!args.mobileAppMode) {
            this.fiStateService.go(
                this.fiStateService.current.name,
                {
                    filterType: args.filterType,
                    sortColumn: args.sortColumn,
                    sortDirection: args.sortDirection,
                    selectedTags: args.selectedTagId,
                    //offset: this.data.length,
                },
                {
                    location: 'replace',
                },
            );
        }
    }
}
